(() => {
  const KEY = 'spot-theme-mode';
  const root = document.documentElement;

  const apply = (dark, animate) => {
    if (animate) {
      root.classList.add('spot-theme-switching');
      window.setTimeout(() => root.classList.remove('spot-theme-switching'), 420);
    }
    root.classList.toggle('spot-dark', dark);
    document.querySelectorAll('[data-spot-theme-toggle]').forEach((btn) => {
      btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
    });
  };

  let dark = false;
  try {
    dark = localStorage.getItem(KEY) === 'dark';
  } catch (error) {
    dark = false;
  }
  apply(dark, false);

  const bind = () => {
    document.querySelectorAll('[data-spot-theme-toggle]').forEach((btn) => {
      if (btn.dataset.spotThemeBound === 'true') return;
      btn.dataset.spotThemeBound = 'true';
      btn.addEventListener('click', () => {
        dark = !root.classList.contains('spot-dark');
        apply(dark, true);
        try {
          localStorage.setItem(KEY, dark ? 'dark' : 'light');
        } catch (error) {
          /* Speichern nicht moeglich, Umschalten funktioniert trotzdem */
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
